import React from "react";
import {connect} from "react-redux";
import OfficeService from "../components/OfficeService";

const mapStateToProps = state => ({

});

const mapDispatchToProps = {

};

const OfficeServiceContainer = () => {
    return (
        <div>
            <OfficeService/>
        </div>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(OfficeServiceContainer);


// WEBPACK FOOTER //
// ./src/container/OfficeServiceContainer.js